var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.pageKey,attrs:{"new-comment-template-paths":_vm.newCommentTemplatePaths,"root-page-full-path":_vm.rootPageFullPath,"with-tabs":_vm.withTabs,"data-testid":"work-item-router-view"}})
}
var staticRenderFns = []

export { render, staticRenderFns }